import { Button, IconButton } from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import { db } from "../../../firebase";
import DonationCard from "../../Atoms/Card/donationCard/DonationCard";
import Loading from "../../Atoms/loading/Loading";
import ReactToPrint from "react-to-print";

import "./Donations.css";
import { Print } from "@material-ui/icons";
function Media() {
  const [donations, setDonations] = useState([]);
  const [saviour, setSaviour] = useState([]);
  const [loading, setLoading] = useState(false);
  const [select, setSelect] = useState("");

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [categories, setCategories] = useState([]);
  // let categories = [];
  // let total = 0;
  const [total, setTotal] = useState(0);
  const printTableRef = useRef();

  // const [calcTotal, setCalcTotal] = useState(false);

  useEffect(() => {
    setDonations([]);

    const fetchData = async () => {
      setLoading(true);
      try {
        const snapshot = await db.collection("Donations").get();
        snapshot.forEach((doc) => setDonations((p) => [...p, doc.data()]));
        snapshot.forEach((doc) => setSaviour((p) => [...p, doc.data()]));
        // snapshot.forEach((doc) =>
        //   setTotal((p) => p + Number(doc.data().donatedAmount))
        // );

        const cateSnap = await db
          .collection("HomePageData")
          .doc("ScreenData")
          .get();
        setCategories(cateSnap.data().donationCategory);
      } catch (e) {
        console.log(e);
      }
      setLoading(false);
    };
    fetchData();
  }, []);

  useEffect(() => {
    // setDonations(saviour);
    if (!select) {
      return;
    }

    if (startDate && endDate) {
      dataFilterHandler();
    } else {
      setDonations(saviour);
    }

    if (select === "dec") {
      setDonations((p) =>
        [...p].sort(
          (a, b) => parseInt(b.donatedAmount) - parseInt(a.donatedAmount)
        )
      );
    } else if (select === "inc") {
      setDonations((p) =>
        [...p].sort(
          (a, b) => parseInt(a.donatedAmount) - parseInt(b.donatedAmount)
        )
      );
    } else if (select === "old") {
      setDonations((p) =>
        [...p].sort((a, b) => a.donatedDate.toDate() - b.donatedDate.toDate())
      );
    } else if (select === "rec") {
      setDonations((p) =>
        [...p].sort((a, b) => b.donatedDate.toDate() - a.donatedDate.toDate())
      );
    } else if (select === "ann") {
      setDonations((p) => p.filter((item) => item.isAnonymous));
    } else if (select === "pub") {
      setDonations((p) => p.filter((item) => !item.isAnonymous));
    }

    //eslint-disable-next-line
  }, [select]);

  useEffect(() => {
    setTotal(0);
    donations.forEach((item) =>
      setTotal((p) => p + Number(item.donatedAmount))
    );
  }, [donations]);

  // console.log(donations);

  const dataFilterHandler = () => {
    // console.log(new Date(endDate));
    // console.log("asdfasdfas");
    // setSelect("");
    setDonations(saviour);
    setDonations((p) =>
      p.filter(
        (item) =>
          item.donatedDate.toDate().setHours(0, 0, 0, 0) >=
            new Date(startDate).setHours(0, 0, 0, 0) &&
          item.donatedDate.toDate().setHours(0, 0, 0, 0) <=
            new Date(endDate).setHours(0, 0, 0, 0)
      )
    );
  };

  return (
    <>
      <div className="donation_filter">
        <div className="donation__filter1">
          <b>Filter:</b>
          <select value={select} onChange={(e) => setSelect(e.target.value)}>
            <option value="" disabled>
              select
            </option>
            <option value="dec">Amount(Dec)</option>
            <option value="inc">Amount(Inc)</option>
            <option value="rec">Recent</option>
            <option value="old">Older</option>
            <option value="ann">Annonymous</option>
            <option value="pub">Non-Annon</option>
          </select>

          <ReactToPrint
            trigger={() => (
              <IconButton>
                <Print style={{ color: "black" }} />
              </IconButton>
            )}
            content={() => printTableRef.current}
          />
        </div>

        <div className="donation__filter2">
          <div>
            <label>
              <b>From:</b>
              <input
                type="date"
                onChange={(e) => {
                  setStartDate(e.target.value);
                }}
                value={startDate}
              />
            </label>
            <label>
              <b>To:</b>
              <input
                type="date"
                onChange={(e) => {
                  setEndDate(e.target.value);
                }}
                value={endDate}
              />
            </label>
          </div>
          <div>
            <Button
              variant="contained"
              color="primary"
              disabled={!(startDate && endDate)}
              onClick={() => {
                setSelect("");
                dataFilterHandler();
              }}
              style={{
                padding: "3px",
                textTransform: "none",
                margin: "0 10px",
              }}
            >
              Apply
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                setStartDate("");
                setEndDate("");
                setSelect("");
                setDonations(saviour);
              }}
              style={{ padding: "3px", textTransform: "none" }}
            >
              Reset
            </Button>
          </div>
        </div>
      </div>
      {loading ? (
        <Loading />
      ) : (
        <div className="donations">
          {donations.map((item) => (
            <DonationCard data={item} key={item.key} categories={categories} />
          ))}
        </div>
      )}
      <div style={{ display: "none" }}>
        <div className="Donations__table" ref={printTableRef}>
          <table>
            <tbody>
              <tr>
                <th>Name</th>
                <th>Date</th>
                <th>Amount</th>
                <th>Contact</th>
                <th>Razor Payment Id</th>
              </tr>
              {donations.map((item) => {
                // total += Number(item.donatedAmount);
                return (
                  <tr key={item.key}>
                    <td>{item.donorName}</td>
                    <td>{item.donatedDate.toDate().toLocaleDateString()}</td>
                    <td>₹ {item.donatedAmount}</td>
                    <td>{item.donorPhoneNumber}</td>
                    <td>{item.paymentID}</td>
                  </tr>
                );
              })}
              <tr>
                <th>Total</th>
                <th></th>
                <th>₹ {total}</th>
                <th></th>
                <th></th>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

export default Media;
